// styles/buttons/HoverButtonOne.js - base button with hover animation
import ButtonOne from './ButtonOne'
import withButtonHover from '../../hoc/withButtonHover' // Import the HOC

// Button with hover animation
const HoverButtonOne = withButtonHover(ButtonOne) // Wrap the button with hover functionality

export default HoverButtonOne
